import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import '../Components/WorkbookStyle.css';
import { Container, Col, Row, Card, Accordion } from 'react-bootstrap'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel'
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-modal'
import axios from 'axios';
import moment from 'moment';

import firebase from 'lib/firebase';
import api from 'lib/api';
import global from 'lib/global';
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';

import * as UserActions from 'store/modules/UserModule';


class MypageAccountItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // 알림모달
            visibleAlert: false,
            alert: '',

            userInfo: {},
            modifyOnOff: false,

            imageLoading: false,
        }
    }

    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(async function (user) {
            let userData = await self.props.userActions.getUserInfo();
            if (userData.data.result) {
                self.setState({ userInfo: userData.data.data });
            }
        });
    }

    onClickCamera = () => {
        console.log("try to change profile pic")
        this.refs.fileUploader.click();
    }
    handleImageChange = async (e) => {
        const self = this;

        let files = e.target.files;
        let token = await firebase.auth().currentUser.getIdToken(true);
        if (!token) {
            return;
        }

        //imageLoad
        const url = global.url_api + '/workbook/imageUpload/upload';
        let formData = new FormData();
        formData.append('file', files[0]);
        formData.append('category', 'profile');
        const config = {
            headers: {
                'accept': 'application/json',
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
            }
        }

        this.setState({ imageLoading: true });
        axios.post(url, formData, config)
            .then(async function (response) {
                self.setState({ imageLoading: false });
                let data = response.data;
                //성공
                if (data.result) {
                    //유저정보 다시 불러오기
                    let userData = await self.props.userActions.getUserInfo();
                    if (userData.data.result) {
                        self.setState({ userInfo: userData.data.data });
                    }

                    self.setState({
                        message: "memo",
                        // isSubmit: false,
                        alert: "Upload complete!",
                        visibleAlert: !self.state.visibleAlert
                    });
                    e.target.value = null;
                } else {
                    self.setState({
                        alert: "Please try again.",
                        visibleAlert: !self.state.visibleAlert
                    })
                }
            })
            .catch(function (err) {
                self.setState({ imageLoading: false });
            })
    };

    //유저정보 수정
    onClickModify = () => {
        // console.log("click modify")
        const self = this;

        let item = this.props.userInfo;
        if (item.level != this.state.userInfo.level || item.nick_name != this.state.userInfo.nick_name) {
            api.post('/workbook/users/change', { item: this.state.userInfo })
                .then(async function (result) {
                    if (result) {
                        // console.log("dataChange result", result)
                        self.setState({
                            alert: "Completed",
                            // visibleAlert: !self.state.visibleAlert,
                            visibleAlert: true,
                        })

                        //유저정보 다시 불러오기
                        let userData = await self.props.userActions.getUserInfo();
                        if (userData.data.result) {
                            self.setState({
                                userInfo: userData.data.data,
                                modifyOnOff: false,
                            });
                        }
                    }
                })
        } else {
            console.log("user informations are same")
        }
    }

    onChangeLevel = (e) => {
        let item = this.state.userInfo;
        item['level'] = e.target.value;
        this.setState({ userInfo: item })

        if (this.props.userInfo.level != this.state.userInfo.level) {
            this.setState({
                modifyOnOff: true
            })
        } else if (this.props.userInfo.level == this.state.userInfo.level && this.props.userInfo.nick_name == this.state.userInfo.nick_name) {
            this.setState({
                modifyOnOff: false
            })
        }

    }

    onChangeUserNick = (e) => {
        console.log("input name")

        let name = e.target.value;
        var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi; //특수문자 제거
        name = name.replace(regExp, "");

        let item = this.state.userInfo;
        item['nick_name'] = name;
        this.setState({ userInfo: item })

        if (this.props.userInfo.nick_name != this.state.userInfo.nick_name) {
            this.setState({
                modifyOnOff: true
            })
        } else if (this.props.userInfo.level == this.state.userInfo.level && this.props.userInfo.nick_name == this.state.userInfo.nick_name) {
            this.setState({
                modifyOnOff: false
            })
        }
    }


    render() {
        let LayoutAccount;
        if (this.props.userInfo && this.props.userInfo.idx) {

            let userProfile = '/profile_empty.png'
            if (this.state.userInfo.photo != null && this.state.userInfo.photo.length > 0) {
                userProfile = this.state.userInfo.photo;
            }

            LayoutAccount = (
                <Container className="mypage_account">
                    <Row style={{
                        borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid',
                        paddingTop: 30, paddingBottom: 30
                    }}>
                        <Col xs={12} sm={12} md={3} lg={3} style={{}}>
                            <div className="profile">
                                <img src={userProfile} alt="profile" style={{ width: '100%', height: '100%' }} />
                            </div>
                            <div className="camera" onClick={this.onClickCamera}>
                                <img src={"/write/my_icon_camera.png"} alt="camera" style={{ width: '70%' }} />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={9} lg={9} style={{}}>
                            <input type="text" placeholder="Nickname" onChange={this.onChangeUserNick} value={this.state.userInfo.nick_name} />
                            <p>{this.state.userInfo.email}</p>
                            <select onChange={this.onChangeLevel} value={this.state.userInfo.level}>
                                <option value={0} disabled hidden>Level select</option>
                                <option value={1}>Beginner</option>
                                <option value={2}>Intermediate - Advanced</option>
                            </select>
                        </Col>
                    </Row>
                    <div className="modify" onClick={this.onClickModify} style={this.state.modifyOnOff == true ? { backgroundColor: '#ce3b33' } : { backgroundColor: '#ccc' }}>Modify</div>
                </Container>
            )
        }

        return (
            <div id="write_ad">
                {LayoutAccount}
                <input type="file" ref="fileUploader" style={{ display: "none" }} onChange={(e) => this.handleImageChange(e)} />

                {/* modal(경고문) */}
                <Modal
                    isOpen={this.state.visibleAlert}
                    onRequestClose={() => this.setState({ visibleAlert: false })}
                    className="Alert"
                    overlayClassName="Overlay"
                >
                    <Container>
                        <Col className="my-auto" style={{ textAlign: "center", color: "#9b9daa", fontSize: 18, padding: 0 }}>{this.state.alert}</Col>
                        <Col className="alertClose" onClick={() => this.setState({ visibleAlert: !this.state.visibleAlert })}>Close</Col>
                    </Container>
                </Modal>
            </div>
        )
    }
}




let mapStateToProps = (state) => ({
    userInfo: JSON.parse(JSON.stringify(state.UserModule.get('userInfo'))),
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MypageAccountItem);